import { getLearningDashboard, getLearningTimeline } from '../../util/api';

// ==========================================
// ACTION TYPES
// ==========================================
export const FETCH_LEARNING_DASHBOARD_REQUEST =
  'app/MyProgressPage/FETCH_LEARNING_DASHBOARD_REQUEST';
export const FETCH_LEARNING_DASHBOARD_SUCCESS =
  'app/MyProgressPage/FETCH_LEARNING_DASHBOARD_SUCCESS';
export const FETCH_LEARNING_DASHBOARD_ERROR =
  'app/MyProgressPage/FETCH_LEARNING_DASHBOARD_ERROR';

export const FETCH_LEARNING_TIMELINE_REQUEST =
  'app/MyProgressPage/FETCH_LEARNING_TIMELINE_REQUEST';
export const FETCH_LEARNING_TIMELINE_SUCCESS =
  'app/MyProgressPage/FETCH_LEARNING_TIMELINE_SUCCESS';
export const FETCH_LEARNING_TIMELINE_ERROR =
  'app/MyProgressPage/FETCH_LEARNING_TIMELINE_ERROR';

// ==========================================
// REDUCER
// ==========================================
const initialState = {
  learningData: null,
  fetchLearningInProgress: false,
  fetchLearningError: null,
  timelineReports: [],
  timelinePage: 1,
  timelineHasMore: false,
  fetchTimelineInProgress: false,
  fetchTimelineError: null,
};

export default function myProgressPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LEARNING_DASHBOARD_REQUEST:
      return {
        ...state,
        fetchLearningInProgress: true,
        fetchLearningError: null,
      };
    case FETCH_LEARNING_DASHBOARD_SUCCESS: {
      const reports = payload?.recentReports || [];
      return {
        ...state,
        fetchLearningInProgress: false,
        learningData: payload,
        timelineReports: reports,
        timelinePage: 1,
        timelineHasMore: payload?.hasMore || false,
      };
    }
    case FETCH_LEARNING_DASHBOARD_ERROR:
      return {
        ...state,
        fetchLearningInProgress: false,
        fetchLearningError: payload,
      };

    case FETCH_LEARNING_TIMELINE_REQUEST:
      return {
        ...state,
        fetchTimelineInProgress: true,
        fetchTimelineError: null,
      };
    case FETCH_LEARNING_TIMELINE_SUCCESS: {
      const newReports = payload?.reports || [];
      return {
        ...state,
        fetchTimelineInProgress: false,
        timelineReports: [...state.timelineReports, ...newReports],
        timelinePage: payload?.page || state.timelinePage + 1,
        timelineHasMore: payload?.hasMore || false,
      };
    }
    case FETCH_LEARNING_TIMELINE_ERROR:
      return {
        ...state,
        fetchTimelineInProgress: false,
        fetchTimelineError: payload,
      };

    default:
      return state;
  }
}

// ==========================================
// ACTION CREATORS
// ==========================================
export const fetchLearningDashboardRequest = () => ({
  type: FETCH_LEARNING_DASHBOARD_REQUEST,
});

export const fetchLearningDashboardSuccess = payload => ({
  type: FETCH_LEARNING_DASHBOARD_SUCCESS,
  payload,
});

export const fetchLearningDashboardError = error => ({
  type: FETCH_LEARNING_DASHBOARD_ERROR,
  payload: error,
});

export const fetchLearningTimelineRequest = () => ({
  type: FETCH_LEARNING_TIMELINE_REQUEST,
});

export const fetchLearningTimelineSuccess = payload => ({
  type: FETCH_LEARNING_TIMELINE_SUCCESS,
  payload,
});

export const fetchLearningTimelineError = error => ({
  type: FETCH_LEARNING_TIMELINE_ERROR,
  payload: error,
});

// ==========================================
// THUNKS
// ==========================================
export const fetchLearningDashboard = ({ userId }) => dispatch => {
  if (!userId) return Promise.resolve(null);
  dispatch(fetchLearningDashboardRequest());
  return getLearningDashboard({ userId, parentId: userId, childId: userId })
    .then(res => {
      const data = res?.data?.data || res?.data || res || {};
      if (data && data.success !== false) {
        dispatch(fetchLearningDashboardSuccess(data));
        return data;
      }
      throw new Error(data?.error || data?.message || 'Failed to fetch learning dashboard');
    })
    .catch(err => {
      const message = err?.message || 'Error loading dashboard';
      dispatch(fetchLearningDashboardError(message));
      throw err;
    });
};

export const fetchLearningTimeline = ({ userId, page = 1, perPage = 10 }) => dispatch => {
  if (!userId) return Promise.resolve(null);
  dispatch(fetchLearningTimelineRequest());
  return getLearningTimeline({
    userId,
    parentId: userId,
    childId: userId,
    page,
    perPage,
  })
    .then(res => {
      const data = res?.data?.data || res?.data || res || {};
      if (data && data.success !== false) {
        dispatch(fetchLearningTimelineSuccess({ ...data, page }));
        return data;
      }
      throw new Error(data?.error || data?.message || 'Failed to fetch learning timeline');
    })
    .catch(err => {
      const message = err?.message || 'Error loading timeline';
      dispatch(fetchLearningTimelineError(message));
      throw err;
    });
};

// ==========================================
// LOAD DATA (ROUTE DATA LOADER)
// ==========================================
export const loadData = (params, search, config) => (dispatch, getState) => {
  const userId = getState().user.currentUser?.id?.uuid;
  if (!userId) {
    return Promise.resolve();
  }
  return dispatch(fetchLearningDashboard({ userId }));
};
